// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.responsive-img {
  width: 100%;
}

.intro-highlights {
  font-family: "poppins", sans-serif;
  font-size: 30px;
  color: #082147;
  font-style: italic;
  line-height: 1.25;
  text-align: center;
  display: block;
  font-weight: 300;
  width: 80%;
  margin: 1rem auto;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 28px;
  margin-bottom: 0.4rem;
}

.key-container {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.section-title-text {
  font-size: 16px;
  color: #082147;
  padding: 0.5rem 1rem;
  background: rgb(227, 241, 255);
  background: linear-gradient(0deg, rgb(227, 241, 255) 0%, rgb(255, 255, 255) 100%);
  font-weight: 700;
  line-height: 28px;
  display: flex;
  justify-content: space-between;
}

.toggle-hide {
  border: 1px solid rgba(13, 32, 101, 0.2);
  border-radius: 0.5rem;
}

.toggle-show {
  border: 1px solid;
  border-color: rgba(13, 32, 101, 0.2);
  border-bottom-width: 0;
  border-radius: 0.5rem 0.5rem 0 0;
}

.icon-up-arrow {
  transform: rotate(180deg);
  transition: transform 500ms ease-in-out;
}

.icon-down-arrow {
  transform: rotate(0deg);
  transition: transform 500ms ease-in-out;
}

.toggle-content {
  display: block;
  padding: 1rem;
  background: rgb(227, 241, 255);
  background: linear-gradient(0deg, rgb(227, 241, 255) 0%, rgb(255, 255, 255) 100%);
  border: 1px solid;
  border-color: rgba(13, 32, 101, 0.2);
  border-top-width: 0;
  border-radius: 0 0 0.5rem 0.5rem;
}

.toggle-content ul {
  list-style-type: none;
}

.toggle-content ul li {
  display: block;
  padding-bottom: 0.75rem;
}

.bold-text-title {
  font-size: 16px;
  color: #082147;
  font-weight: 700;
  line-height: 28px;
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/pages/About/About.scss","webpack://./src/assets/mixins/reset.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA1EA;EACE,WAAA;AA6EF;;AA1EA;EACE,kCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AA6EF;;AA3EA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AA8EF;;AA5EA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AA+EF;;AA7EA;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EAEA,8BAAA;EACA,iFAAA;EAKA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AA2EF;;AAxEA;EACE,wCAAA;EACA,qBAAA;AA2EF;;AAzEA;EACE,iBAAA;EACA,oCAAA;EACA,sBAAA;EACA,gCAAA;AA4EF;;AA1EA;EACE,yBAAA;EACA,uCAAA;AA6EF;;AA3EA;EACE,uBAAA;EACA,uCAAA;AA8EF;;AA5EA;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,iFAAA;EAKA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gCAAA;AA2EF;;AAzEA;EACE,qBAAA;AA4EF;;AA1EA;EACE,cAAA;EACA,uBAAA;AA6EF;;AA3EA;EACE,eAAA;EACA,cAAA;EAEA,gBAAA;EACA,iBAAA;EACA,eAAA;AA6EF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.responsive-img {\n  width: 100%;\n}\n\n.intro-highlights {\n  font-family: \"poppins\", sans-serif;\n  font-size: 30px;\n  color: #082147;\n  font-style: italic;\n  line-height: 1.25;\n  text-align: center;\n  display: block;\n  font-weight: 300;\n  width: 80%;\n  margin: 1rem auto;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  line-height: 28px;\n  margin-bottom: 0.4rem;\n}\n\n.key-container {\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.section-title-text {\n  font-size: 16px;\n  color: #082147;\n  padding: 0.5rem 1rem;\n  background: rgb(227, 241, 255);\n  background: linear-gradient(0deg, rgb(227, 241, 255) 0%, rgb(255, 255, 255) 100%);\n  font-weight: 700;\n  line-height: 28px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.toggle-hide {\n  border: 1px solid rgba(13, 32, 101, 0.2);\n  border-radius: 0.5rem;\n}\n\n.toggle-show {\n  border: 1px solid;\n  border-color: rgba(13, 32, 101, 0.2);\n  border-bottom-width: 0;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.icon-up-arrow {\n  transform: rotate(180deg);\n  transition: transform 500ms ease-in-out;\n}\n\n.icon-down-arrow {\n  transform: rotate(0deg);\n  transition: transform 500ms ease-in-out;\n}\n\n.toggle-content {\n  display: block;\n  padding: 1rem;\n  background: rgb(227, 241, 255);\n  background: linear-gradient(0deg, rgb(227, 241, 255) 0%, rgb(255, 255, 255) 100%);\n  border: 1px solid;\n  border-color: rgba(13, 32, 101, 0.2);\n  border-top-width: 0;\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n\n.toggle-content ul {\n  list-style-type: none;\n}\n\n.toggle-content ul li {\n  display: block;\n  padding-bottom: 0.75rem;\n}\n\n.bold-text-title {\n  font-size: 16px;\n  color: #082147;\n  font-weight: 700;\n  line-height: 28px;\n  display: inline;\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
